<template>
  <div class="container-fluid mt--6 tbl-flt-sch">
    <div class="abs-btn-grp">
          <div v-if="selectedCount > 0" class="selection-chip align-self-center mr-2">
            <span class="selection-chip__count">Selected: {{ selectedCount }}</span>
            <button @click="clearSelection()" type="button" class="selection-chip__clear" title="Clear selection">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="dropdown">
          <button :disabled="invUploadStatus == 'INPROGRESS' "  class="btn btn-warning rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div v-if="invUploadStatus == 'INPROGRESS'" style="color:black">
              <i class="fa fa-spinner fa-spin"></i>  IMPORTING..
            </div> 
            <div v-if="!invUploadStatus">
              <i class="fas fa-upload"></i>  IMPORT
            </div>  
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <a class="dropdown-item cursor-pointer" @click="openImportInventoryModal()">HOLDINGS</a>
            <a class="dropdown-item cursor-pointer" @click="openInvAccHoldingModal()">INVENTORY ACCOUNT HOLDINGS</a>
            <a class="dropdown-item cursor-pointer" @click="openAddInvModal()">ADD NEW</a>
          </div>
        </div>

          <button @click="exportDataCheck()" type="button" class="btn btn-danger rounded">
            <span v-if="!isExport"> <i class="fas fa-download"></i> EXPORT</span>
            <span v-if="isExport"><i class="fa fa-spinner fa-spin"></i> EXPORTING..</span>
          </button> 
          <div class="dropdown">
          <button   class="btn btn-success rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div>
              <i class="fas fa-paper-plane"></i> SEND
            </div>   
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
            <a class="dropdown-item cursor-pointer" @click="sendToOperator()">SEND TO OPERATOR</a>
            <a class="dropdown-item cursor-pointer" @click="sendToEcn()">SEND TO ECN</a>
            <a class="dropdown-item cursor-pointer" @click="sendAllToOperator()">SEND ALL TO OPERATOR</a>
            <a class="dropdown-item cursor-pointer" @click="sendAllToEcn()">SEND ALL TO ECN</a>
          </div>
        </div>
          <!-- <Button @click="sendToOperator()" type="button" class="btn btn-success" ><i class="fas fa-paper-plane"></i> SEND TO OPERATOR</Button> -->
          <!-- <Button @click="sendToEcn()" type="button" class="btn btn-success"><i class="fas fa-paper-plane"></i> SEND TO ECN</Button> -->
          <Button @click="showApplyFilterModal()" type="button" class="btn btn-info"><i class="fas fa-filter"></i> APPLY FILTERS</Button>
    </div>
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
                  <!-- <div class="row">
                      <div class="col-md-10"></div>
                      <div class="col-md-2">
                          <toggle-button v-model="isHoldingFilled" @change="onChangeEventHandler"/> Holding Filled
                      </div>
                  </div>  -->

                  <div class="sch-sticky" style="display: flex; justify-content: space-between;">
                     <!-- <Button @click="showFilters()" :class="{ active: applyiedFilter }" type="button" class="btn btn-custom mt-2 float-right"><i class="fas fa-filter"></i> Filters </Button> -->
                     
                    <div class="d-flex">
                     <div class="dropdown mt-2 ml-2">
                      <button class="btn btn-success  rounded dropdown-toggle ml-2 mt-0" type="button"
                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div>
                          <i aria-hidden="true" class="fa fa-filter"></i> SAVED FILTERS
                        </div>
                      </button>

                      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" style="max-height: 300px; overflow-y: scroll;">
                        <a v-for="filter in savedFilterList" v-bind:key="filter.id" class="dropdown-item">
                          <div class="d-flex justify-content-between">
                            <span class="cursor-pointer" @click="filterBySavedFilter(filter.id)">{{ filter.filterName
                              | truncate(20, '...')}} </span>
                              <div>
                                <span>
                                  <i class="cursor-pointer fas fa-pencil-alt" @click="editFlter(filter.id)"></i>
                                </span>
                                <span class="ml-3">
                                  <i class="text-danger cursor-pointer fas fa-trash-alt" @click="deleteFlter(filter.id)"></i>
                                </span>
                              </div>
                            
                          </div>
                        </a>
                      </div>
                    </div>
                    <div v-if="applyiedFilter || selectedFilterId" class="mt-3">
                        <span v-if="selectedFilterId" class="active-filter mr-2">{{ getFilterName(selectedFilterId) }}</span>
                        <span @click="clearFilters()" class="text-info cursor-pointer">Clear Filters</span>
                     </div>
                         <div>
                        <h6 class="d-flex justify-content-center ml-3">ECN Status</h6>
                      <div class="inventory-legend ml-4">
                          <span class="legend-color dark-green-legend" title="All ECN Sent"></span>
                          <span class="legend-color light-green-legend" title="Partial ECN Sent"></span>
                          <span class="legend-color dark-blue-legend" title="All Operator Sent"></span>
                          <span class="legend-color light-blue-legend" title="Partial Operator Sent"></span>
                          <span class="legend-color pink-orange" title="Inventory Offer Exists"></span>
                        </div>
                        </div>
                    </div>
                     <div class="input-group col-md-3 tab-sch tbl-sch rounded">
                      <h5 class="cursor-pointer mt-3 mr-3" @click="selectColumnOption()">
                        <i class="fa fa-cog"></i>
                        Column Options
                      </h5>
                      <input v-on:keyup.enter="searchHolding" type="text" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control rounded" placeholder="Search" />
                      <span v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
                      <span @click="searchHolding()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>
                    </div>
                    
                  </div>
                  <table class="table align-items-center table-flush table-hover bidtbl bid-acc stkytbl-margin">
                      <thead class="thead-light psticky">
                      <tr >
                        <th 
                          scope="col" 
                          class="text-center"
                          >SELECT</th>
                        
                          <th 
                            class="text-center sort" 
                             scope="col" 
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == column.key  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == column.key  ? 'sort-desc' : '']"  
                            @click="sort(column.key)" 
                           
                            v-for="(column, index) in columnHeaders" :key="index"
                          >{{
                            column.name.replace(/_/g, ' ') }}</th>
                        <th 
                        scope="col" 
                        class="sort text-left"
                        >SELL QTY</th> 
                        <th 
                        scope="col" 
                        class="sort text-left"
                        >SPREAD</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >ACTION</th>
                      </tr>
                      </thead>
                      <tbody class="list">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="holding in holdingsList" :key="holding.selectionKey"  >
                        <td class="text-center"  >
                          <input  v-model="holding.isSelect" @change="selectHolding(holding)" type="checkbox" class="form-check-input" />
                        </td>
                        <td class="text-center" v-for="(column, index) in columnHeaders" :key="index">
                          <span v-if="column.key == 'customerAccount'">
                                <span >{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                            <div v-for="inv in holding.invDetails"  :key="inv.id">
                                <span>{{inv.accountVal}}</span> | 
                                <span >{{inv.accountType}}</span>
                              </div>
                            <!-- <span >{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                            <span>{{holding.accountVal}}</span> | 
                            <span >{{holding.accountType}}</span>  -->
                          </span>
                          <span v-if="column.key == 'cusipDesc'">
                            <span class="cusip-highlight" :class="getRowColor(holding.color)">{{holding.cusipVal}}</span><br>
                            <span data-toggle="tooltip" data-placement="left"  v-bind:title='holding.cusipDescription'>{{holding.cusipDescription | truncate(20, '...')}}</span>
                          </span>
                          <span v-if="column.key == 'coupon'">
                            <span>{{holding.coupon |  percent(3) }}</span>
                          </span>
                          <span v-if="column.key == 'maturAndcallDate'">
                            <span class="">{{holding.maturityDate ? moment(holding.maturityDate).format("MM/DD/YYYY") : "N/A"}}</span><br>
                            {{holding.callDate ? moment(holding.callDate).format("MM/DD/YYYY") : "N/A"}}
                          </span>
                          <span v-if="column.key == 'rating'">
                            {{holding.ratingMoody ? holding.ratingMoody : "N/A"}}
                            <span class="insurer">{{holding.ratingSP ? holding.ratingSP : "N/A"}}</span>
                          </span>
                          <span v-if="column.key == 'bondInsurer'">
                            {{holding.bondInsurer ? holding.bondInsurer : "N/A"}}
                          </span>
                          <span v-if="column.key == 'boughtDate'">
                            <div v-if="holding.boughtDate">
                              <div v-for="(date, index) in holding.boughtDate.split(',')" :key="index">
                                {{ date }}
                              </div>
                            </div>
                          </span>
                          <span v-if="column.key == 'cost'">
                            <span >{{holding.cost | currency}}</span><br>
                          </span>
                          <span v-if="column.key == 'closingPx'">
                            <span >{{holding.closingPx | currency }}</span><br>
                          </span>
                          <span v-if="column.key == 'quantity'">
                            <span>{{holding.quantity}}</span><br>
                          </span>
                          <span v-if="column.key == 'remainQuantity'">
                            <span>{{holding.remainQuantity }}</span><br>
                          </span>
                          <span v-if="column.key == 'gainLossPrice'">
                            <span>{{holding.gainLossPrice | currency }}</span><br>
                          </span>
                          <span v-if="column.key == 'gainLossPercentage'">
                            <span>{{holding.gainLossPercentage }}</span><br>
                          </span>
                          <span v-if="column.key == 'state'">
                            <span>{{holding.state }}</span><br>
                          </span>
                          <span v-if="column.key == 'cashAvailable'">
                            <span>{{holding.cashAvailable  | currency}}</span><br>
                          </span>
                        </td>

                        <!-- <td class="text-left">
                          <span >{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                          <span>{{holding.accountVal}}</span> | 
                          <span class="text-success">{{holding.accountType}}</span> 
                        </td>
                        <td class="text-center">
                            <span class="cusips">{{holding.cusipVal}}</span><br>
                            <span data-toggle="tooltip" data-placement="left"  v-bind:title='holding.cusipDescription'>{{holding.cusipDescription | truncate(20, '...')}}</span>
                        </td>
                        <td class="text-center"><span>{{holding.coupon |  percent(3) }}</span></td>
                        <td class="text-center">
                          <span class="maturity">{{holding.maturityDate ? moment(holding.maturityDate).format("MM/DD/YYYY") : "N/A"}}</span><br>
                        {{holding.callDate ? moment(holding.callDate).format("MM/DD/YYYY") : "N/A"}}
                        </td>
                        <td class="text-center"><span class="text-primary">{{holding.ratingMoody ? holding.ratingMoody : "N/A"}}</span>
                            <span class="insurer text-success">{{holding.ratingSP ? holding.ratingSP : "N/A"}}</span>
                        </td>
                        <td class="text-center"><span class="insurer">{{holding.bondInsurer ? holding.bondInsurer : "N/A"}}</span></td>
                        <td class="text-center">
                            <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span>
                        </td>
                        <td class="text-center">
                            <span class="text-success">{{holding.cost}}</span><br>
                        </td>
                        <td class="text-center">
                            <span class="text-danger">{{holding.closingPx}}</span><br>
                        </td>
                        <td class="text-center">
                            <span>{{holding.quantity}}</span><br>
                        </td> 
                        <td class="text-center">
                            <span>{{holding.quantity - holding.filledQuantity }}</span><br>
                        </td>  -->
                        <td class="text-center">
                            <span class="sell-qty"><input type="number" class="form-control" placeholder="Qty"  v-model.number="holding.sellQuantity"></span><br>
                        </td> 
                        <td class="text-center">
                            <span class="sell-qty"><input type="number" class="form-control" placeholder="Spread"  v-model.number="holding.spread"></span><br>
                        </td> 
                        <td class="text-center">
                          <button :disabled="!holding.sellQuantity" @click="sendToOperatorSingle(holding)" type="button" class="btn btn-primary" >SEND TO OPERATOR</button>
                          <button :disabled="!holding.sellQuantity"  @click="sendToEcnSingle(holding);selectedHolding = holding" type="button" class="btn btn-success" >SEND TO ECN</button>

                        </td>
                        </tr>
                      </tbody>
                      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                  </table>
                  <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getHoldingList(applyiedFilter, true)"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
            </div>
          </div>
        </div>
      </div>
    <CreateBidWanted v-if="createBidWantedModalOpen" v-bind:holding="sendToEcnHoldings" v-bind:isTraderDirectSendToEcn="true" @close="toggleCreateBidWantedModalOpen()" />
    <ImportInventory v-if="importInventoryModal" @close="closeImportInventoryModal()" />
    <ImporInventoryAccount v-if="importInventoryAccModal" @close="closeImportInventoryModal()" />  
    <AddNewInventory v-if="addInvModalOpen" v-bind:selectedInventory="{}" v-bind:mode="'ADD'" @close="closeAddInvModal()" />
    <SendToOperator v-if="sendToOperatorModalOpen" v-bind:holding="sendToOperatorHoldings" @close="toggleSendToOperatorModal()"/>
    <FilterModal 
      v-if="showFilterModal" 
      v-bind:editFilterId="editFilterId" 
      v-bind:loadFilterId="loadFilterId"
      v-bind:activeFilter="applyiedFilter" 
      v-on:applySavedFilter="applySavedFilter"  
      v-on:applyFilter="applyFilter"  
      @close="showFilters()"/>
    <ColumnOption  v-if="showColumnOption" @close="selectColumnOption()" />  
    <SendAllBidWanted v-if="sendAllBidWantedModalOpen" v-bind:sendAllMode="sendAllMode" v-bind:sendAllResult="sendAllResult" v-bind:sendAllPayload="sendAllPayload" @close="toggleSendAllBidWantedModalOpen()"/>

  </div>    

</template>
<script>
import config from "@/config";
import authService from "@/authService";
// import Datepicker from 'vuejs-datepicker';
import CreateBidWanted from '../../ba-common/BaCreateBidWantedModal';
import SendToOperator from '../../ba-common/BaSendToOperatorModal';
import SendAllBidWanted from '../../ba-common/BaSendAllBidWantedModal';
import ImportInventory from "@/components/ims/ims-inventory/ImsImportInventoryModal";
import ImporInventoryAccount  from "@/components/ims/ims-inventory/ImsImportInventoryAccountModal";
import AddNewInventory  from "@/components/ims/ims-inventory/ImsAddInventoryModal";
import FilterModal  from  '../../ba-trader/holdings/BaFilters';
import ColumnOption  from '../../ba-trader/holdings/BaColumnOptions';
import baColumnOptions from "@/baColumnOptions";

export default {
  name: "baAllHoldingsTrader",
  components : {
    // Datepicker,
    CreateBidWanted,
    ImporInventoryAccount,
    ImportInventory,
    AddNewInventory,
    SendToOperator,
    FilterModal,
    ColumnOption,
    SendAllBidWanted

    
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 20,
        searchValue : "",
        totalRows : 0,
        sortColumn: "cusipDesc",
        sortOrder: "ASC",
        holdingsList : [],
        createBidWantedModalOpen : false,
        importInventoryModal : false,
        importInventoryAccModal : false,
        selectedHolding : null,
        addInvModalOpen : false,
        isHoldingFilled : false,
        invUploadStatus : localStorage.getItem("INVUPLOADSTATUS"),
        sendToOperatorModalOpen : false,
        sendToOperatorHoldings : [],
        sendToEcnHoldings : [],
        selectedHoldingsMap : {},
        showFilterModal : false,
        applyiedFilter : null,
        savedFilterList : [],
        selectedFilterId : null,    
        editFilterId : null,
        loadFilterId : null,    
        isExport : false,
        showColumnOption : false,
        columnHeaders: [],
        sendAllBidWantedModalOpen : false,
        sendAllPayload : null,
        sendAllResult : null,
        sendAllMode : null

    };
  },
  computed: {
    selectedCount(){
      return Object.keys(this.selectedHoldingsMap).length;
    }
  },
  methods: {
    selectionKey(holding, index){
      if(holding.id !== undefined && holding.id !== null){
        return "id-" + holding.id;
      }
      if(Array.isArray(holding.invDetails) && holding.invDetails.length > 0){
        return "inv-" + holding.invDetails.map(inv => inv.id).join("-");
      }
      return "row-" + this.currentPage + "-" + index;
    },
    selectHolding(holding){
      if(holding.isSelect){
        this.$set(this.selectedHoldingsMap, holding.selectionKey, holding);
      }else{
        this.$delete(this.selectedHoldingsMap, holding.selectionKey);
      }
    },
    clearSelection(){
      this.selectedHoldingsMap = {};
      this.holdingsList.forEach(holding => {
        holding.isSelect = false;
      });
    },
    // Keeps the checkboxes of previously selected rows ticked when a page is revisited.
    retainSelection(holdings){
      holdings.forEach((holding, index) => {
        holding.selectionKey = this.selectionKey(holding, index);
        if(this.selectedHoldingsMap[holding.selectionKey]){
          holding.isSelect = true;
          this.selectedHoldingsMap[holding.selectionKey] = holding;
        }
      });
    },
     sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getHoldingList(null, true);
    },
    toggleSendAllBidWantedModalOpen() {
      this.sendAllBidWantedModalOpen = !this.sendAllBidWantedModalOpen;
    },
    sendAllToEcn(){
      this.loading = true;
      const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        var postData = {};
            postData.status = ['NEW'];
            postData.sortColumn = this.sortColumn;
            postData.sortOrder =  this.sortOrder;
            postData.listFilled =  this.isHoldingFilled;
            postData.showCountOnly =  true;
            postData.traderCognitoSub =  authService.getUser().cognitoSub;
            postData.userId =  authService.getUser().id;
            postData.createSource =  "IMS";

        if(this.selectedFilterId){
          postData.filterId =  this.selectedFilterId;
        }else{
          postData.filterId =  ""
        } 
        
        if(this.applyiedFilter && !this.selectedFilterId){
          postData = { ...postData, ...this.applyiedFilter };
        } 

        this.sendAllPayload = postData;
    

        this.$http
        .post(
           config.baseUrlAutoBidder +
            "/bidwanted/sendall-to-ecn",postData,
            auth
        )
        .then((result) => {
          this.sendAllResult = result.data;
          this.loading = false;
          this.sendAllMode = "ECN";
          this.toggleSendAllBidWantedModalOpen()
        }).catch(() => this.loading = false);

    },
    sendAllToOperator(){
      this.loading = true;
      const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        var postData = {};
            postData.status = ['NEW'];
            postData.sortColumn = this.sortColumn;
            postData.sortOrder =  this.sortOrder;
            postData.listFilled =  this.isHoldingFilled;
            postData.showCountOnly =  true;
            postData.traderCognitoSub =  authService.getUser().cognitoSub;
            postData.userId =  authService.getUser().id;
            postData.createSource =  "IMS";

        if(this.selectedFilterId){
          postData.filterId =  this.selectedFilterId;
        }else{
          postData.filterId =  ""
        } 
        
        if(this.applyiedFilter && !this.selectedFilterId){
          postData = { ...postData, ...this.applyiedFilter };
        } 

        this.sendAllPayload = postData;

        this.$http
        .post(
           config.baseUrlAutoBidder +
            "/bidwanted/sendAllToOperator",postData,
            auth
        )
        .then((result) => {
          this.sendAllResult = result.data;
          this.loading = false;
          this.sendAllMode = "OPERATOR";
          this.toggleSendAllBidWantedModalOpen()
        }).catch(() => this.loading = false);

    },
    getSavedColumnOptions() {
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
          .get(
          config.baseUrlBidSide +
              "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
              auth
          )
          .then(result => {
              this.userSettings = result.data;
              this.userSettings.forEach(element => {
                if(element.setting == "INVENTORY_HOLDING_COLUMN_ORDER"){
                  let columnData = JSON.parse(element.value);
                  console.log(columnData)
                  this.columnHeaders =   columnData.selectedHeaders.filter(column => column.isSelected);
                  this.sortColumn =   columnData.sortColumn ? columnData.sortColumn : 'cusipDesc';
                  this.sortOrder =   columnData.sortOrder ? columnData.sortOrder : 'ASC';
                }      
              }); 
              if(this.columnHeaders.length == 0){
                this.columnHeaders = [...baColumnOptions];
                this.sortColumn =   'cusipDesc';
                this.sortOrder =   'ASC';
              }  
              this.getHoldingList(null, true);
          })
          .catch(e => {
              console.log(e);
          });
    },
    selectColumnOption() {
      this.showColumnOption = !this.showColumnOption;
        if (!this.showColumnOption)
          this.getSavedColumnOptions()
      },
    exportDataCheck(){
      let inventoryIds = Object.values(this.selectedHoldingsMap)
            .filter(holding => Array.isArray(holding.invDetails)) // has invDetails array
            .flatMap(holding => holding.invDetails.map(d => d.id)); // extract all IDs
        

      if(inventoryIds.length){
          let data = {
          "inventoryIds": inventoryIds,
          "clientName":"drl",
          "cognitoSub": authService.getUser().cognitoSub
        }
        this.exportData(data)
      }

      if(!inventoryIds.length){
        var message = "You are about to download all inventories from the search results. Would you like to continue?";
        this.$confirm(message,"Export","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          let data = {
            "clientName":"drl",
            "cognitoSub": authService.getUser().cognitoSub,
            "search": this.searchValue
            
          }
          if(this.selectedFilterId){
            data.filterId =  this.selectedFilterId;
          }else{
            data.filterId =  ""
          } 
          if(this.applyiedFilter && !this.selectedFilterId){
            data = { ...data, ...this.applyiedFilter };
          } 
          this.exportData(data)
        })


      } 

    },
    exportData(data) {
      this.isExport = true;
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
        .post(
          config.baseUrlAutoBidder +
          "/bidwanted/inventory-exceldownload", data,
          auth
        )
        .then((response) => {
          this.isExport = false;
          if(response.data){
              window.open(response.data, "_blank");
            }
          // this.$alert("Export is in progress, download file from File Logs once completed", "", "success");

        })
        .catch(e => {
          console.log(e);
          this.isExport = false;
        });
    },
    getSavedFilter(id) {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
          "/bidwanted/filter-dropdown?userId=" + authService.getUser().id,
          auth
        )
        .then((res) => {
          this.savedFilterList = res.data.content;
          if (id) {
            this.selectedFilterId = id
            this.getHoldingList(null, true); 

          }
        })
        .catch(e => {
          console.log(e);
        });
      },
    filterBySavedFilter(id){
        this.selectedFilterId = id;
        this.applyiedFilter = null;
        this.getHoldingList(null, true); 
    },  
    editFlter(id){
      this.loadFilterId = null;
      this.editFilterId = id;
      this.showFilters()
    },
    deleteFlter(id){
      var message = "Are you sure you want to delete this filter?";
        this.$confirm(message,"Delete","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        };
        this.$http
          .put(
            config.baseUrlAutoBidder +
            "/bidwanted/filter-statusupdate",{"filterId":id,"status":"DELETED"},
            auth
          )
          .then(() => {
            this.$alert("Filter deleted.", "", "success");
            if(this.selectedFilterId == id){
              this.clearFilters()
            }
            this.getSavedFilter();
          })
          .catch(e => {
            console.log(e);
          });
        })
    },
    showApplyFilterModal(){
      this.editFilterId = null;
      this.loadFilterId = this.selectedFilterId || null;
      this.showFilters()

    },
    showFilters(){
      // console.log("dd");
      if(this.showFilterModal){
        this.getSavedFilter();
        this.loadFilterId = null;
        this.editFilterId = null;
      }
      this.showFilterModal = !this.showFilterModal
    },
    onChangeEventHandler(){
        this.getHoldingList(null, true); 
    },
    openAddInvModal(){
      this.addInvModalOpen = true;
    }, 
    closeAddInvModal(){
      this.addInvModalOpen = false;
      this.getHoldingList();
    },
    toggleSendToOperatorModal(){
      this.sendToOperatorModalOpen = !this.sendToOperatorModalOpen;
      if(!this.sendToOperatorModalOpen){
        this.getHoldingList(); 
      }
    },
    openImportInventoryModal(){
        this.importInventoryModal = true;
    }, 
    openInvAccHoldingModal(){
      this.importInventoryAccModal = true;
    }, 
    closeImportInventoryModal(){
      this.importInventoryModal = false;
      this.importInventoryAccModal = false;
      this.getHoldingList();
      this.invUploadStatus = localStorage.getItem("INVUPLOADSTATUS");
    },   
    checkValid(holding){
      let isValid = true;
      let cusipType = holding.offeringTypeId === 1 ? "Munis" : "Corporates";
      if(!holding.sellQuantity){
        this.$alert("Fill all holdings sell quantity","","error");
        isValid = false;
        return;
      }
      if((holding.quantity - holding.filledQuantity ) < holding.sellQuantity){
        this.$alert("Quantity entered is greater than available quantity.","","error");
        isValid = false;
        return;
      }
      if(cusipType == 'Munis' &&  holding.sellQuantity % 5 != 0 ){
        this.$alert("Holding quantity is not multiples of 5","","error");
        isValid = false;
       return ;
      }
      return isValid
    },
    sendToEcnSingle(holding){
      if(this.checkValid(holding)){
          this.sendToEcnHoldings = [];
          this.sendToEcnHoldings.push(holding);
          this.toggleCreateBidWantedModalOpen();    
      }
    },
    sendToEcn(){
      this.sendToEcnHoldings = Object.values(this.selectedHoldingsMap);
      if(this.sendToEcnHoldings.length == 0){
        this.$alert("Please select any holding","","error");
        return false
      }
      // const unique = [...new Set(this.sendToEcnHoldings.map(item => item.cusipVal))];
      // if(unique.length > 1){
      //   this.$alert("Please select holding with same cusip","","error");
      //   return false
      // }
      this.toggleCreateBidWantedModalOpen();
    },
    sendToOperatorSingle(holding){
      if(this.checkValid(holding)){
        this.sendToOperatorHoldings = [];
        this.sendToOperatorHoldings.push(holding)
        this.toggleSendToOperatorModal();
      }
    },
    sendToOperator(){
      this.sendToOperatorHoldings = Object.values(this.selectedHoldingsMap);
      if(this.sendToOperatorHoldings.length == 0){
        this.$alert("Please select any holding","","error");
        return false
      }
      // const unique = [...new Set(this.sendToOperatorHoldings.map(item => item.cusipVal))];
      // if(unique.length > 1){
      //   this.$alert("Please select holding with same cusip","","error");
      //   return false
      // }
      this.toggleSendToOperatorModal();
    },
    toggleCreateBidWantedModalOpen(){
      this.createBidWantedModalOpen = !this.createBidWantedModalOpen;
      if(!this.createBidWantedModalOpen){
        this.getHoldingList();  
      }
    },
    searchHolding(){
      this.currentPage = 1;
      this.getHoldingList(null, true); 
    },
    getFilterName(id){
      let filter = this.savedFilterList.find((data) => data.id === id);
      return filter ? filter.filterName : "";
    },
    clearSearch(){
      this.searchValue = "";
      this.currentPage = 1;
      this.getHoldingList(null, true); 
    },
    applyFilter(data){
      this.applyiedFilter = data;
      this.selectedFilterId = null;
      this.getHoldingList(data, true);
      this.getSavedFilter();
    },
    applySavedFilter(savedFilterId){
      this.getSavedFilter(savedFilterId);
    },
    clearFilters(){
      this.applyiedFilter = null;
      this.selectedFilterId = null;
      this.getHoldingList(null, true)
    },
    getHoldingList(filterData, keepSelection){
      this.loading = true;
        if(keepSelection !== true){
          this.clearSelection();
        }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        var postData = {};
            postData.page = this.currentPage;
            postData.size = this.perPage;
            postData.search = this.searchValue;
            postData.status = ['NEW'];
            postData.sortColumn = this.sortColumn;
            postData.sortOrder =  this.sortOrder;
            postData.listFilled =  this.isHoldingFilled;
        if(this.selectedFilterId){
          postData.filterId =  this.selectedFilterId;
        }else{
          postData.filterId =  ""
        } 
        
        // Prefer explicit filterData; fall back to applied filter so refresh
        // after BW send / modal close still keeps search + filter together
        const activeFilter = filterData || this.applyiedFilter;
        if(activeFilter && !this.selectedFilterId){
          postData = { ...postData, ...activeFilter };
        } 

        this.$http
        .post(
           config.baseUrlAutoBidder +
            "/bidwanted/inventory-listall",postData,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(holding => {
            holding.isOperatorDirectSendToEcn = true;
            holding.sellQuantity =  holding.remainQuantity;

          });
          this.retainSelection(result.data.content);
          this.holdingsList = result.data.content;

          this.loading = false;
        }).catch(() => this.loading = false);
    },
    // sendToOperator(holding){
    //   let cusipType = holding.offeringTypeId === 1 ? "Munis" : "Corporates";
    //   if((holding.quantity - holding.filledQuantity ) < holding.sellQuantity){
    //     this.$alert("Quantity entered is greater than available quantity.","","error");
    //     return;
    //   }
    //   if(cusipType == 'Munis' &&  holding.sellQuantity % 5 != 0 ){
    //       this.$alert("Holding quantity is not multiples of 5","","error");
    //       return ;
    //   }
    //   var message = `Are you sure you want to send this holding with a quantity of ${holding.sellQuantity} to the operator?`;
    //   this.$confirm(message,"","question",{confirmButtonText:"SEND TO OPERATOR",cancelButtonText : "NO"}).then(() => {
    //     this.loading = true;
    //       const auth = {
    //           headers: { 'org-token' : authService.getOrgToken()  }
    //       };
    //       let data = {
    //         "cusipId":holding.cusipId,
    //         "inventoryId":holding.id,
    //         "sellQuantity":holding.sellQuantity,
    //         "traderCognitoSub":authService.getUser().cognitoSub,
    //         "spread":holding.spread,
    //         }
    //       this.$http
    //       .post(config.baseUrlBidSide + "/bidwanted",data,auth)
    //       .then(() => {
    //         this.loading = false;              
    //         this.getHoldingList();
    //         this.$alert("Your holding has been successfully sent to operator","","success")
    //       })
    //       .catch(() => {
    //           this.loading = false;              
    //       });
    //   })
    // }
  },
  mounted() {
    this.getSavedColumnOptions();
    this.getSavedFilter();
    this.$root.$on("INVUPLOADCOMPLETED", () => {
      this.invUploadStatus = null;
    });
  }
};
</script>
<style scoped>
/* Keep all toolbar actions on a single row when a selection is active */
.abs-btn-grp {
  max-width: min(72%, calc(100% - 60px));
  column-gap: 6px;
}

/* Compact selection indicator (replaces the bulky badge + full-width button) */
.selection-chip {
  display: inline-flex;
  align-items: center;
  height: 38px;
  padding: 0 4px 0 12px;
  background: #fff;
  border-radius: 5px;
  color: #303030;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.selection-chip__count {
  line-height: 1;
}
.selection-chip__clear {
  border: 0;
  background: transparent;
  color: #9aa0a6;
  cursor: pointer;
  padding: 6px 8px;
  margin-left: 2px;
  line-height: 1;
  border-radius: 4px;
  transition: color 0.15s ease, background 0.15s ease;
}
.selection-chip__clear:hover {
  color: #e53935;
  background: #f2f2f2;
}

.sell-qty input{
  margin: auto;
}
.bidaccumlator-actions .btn{
  padding: 4px 5px !important;
}
.dropdown-item{
  margin-top: 10px !important;
}
</style>